import React from 'react'

function Status(props) {
  return (
    <div className="status-div">
          <div className="status" style={{ width: `${props.count}%` }}></div>
        </div>
  )
}

export default Status
